import React, { useEffect, useState } from "react";
import { decodeHtml } from "../../../../../assests/extention/commonfunction";
import ReactSelect from "react-select";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useSelector } from "react-redux";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { currentYear } from "../../../../Common/FewCommonMethods";
import AsteriskLabel from "../../../../Common/AsteriskLabel";
import YearRange from "../../../../Common/YearRange";
import OnlyYearRange from "../../../../Common/OnlyYearRange";

const options = [
  { value: "1", label: "BE" },
  { value: "2", label: "BCA" },
  { value: "3", label: "MBA" },
  { value: "4", label: "B.COM" },
];

const generateDateOptions = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 1990;
  const optionsDate = [];

  for (let year = startYear; year <= currentYear; year++) {
    optionsDate.push({
      value: year.toString(),
      label: year.toString(),
    });
  }

  return optionsDate;
};

const validationSchema = Yup.object().shape({
  university: Yup.string().required("University is required"),
  field: Yup.string().required("Field of Study is required"),
  degree_id: Yup.string().required("Degree is required"),
  from_year: Yup.string().required("From year is required"),
  to_year: Yup.string()
    .required("To year is required")
    .test(
      "date-comparison",
      "To year must be greater than or equal to From year",
      function (value) {
        const { from_year } = this.parent;
        return parseInt(value) >= parseInt(from_year);
      }
    )
    .test(
      "year-gap",
      "Gap between From year and To year must not exceed 10 years",
      function (value) {
        const { from_year } = this.parent;
        if (!from_year || !value) return true;
        const gap = parseInt(value) - parseInt(from_year);
        return gap <= 10;
      }
    ),
});


const IAddEduction = ({ formData, setFormData, nextPage, previousPage }) => {
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [updateIndex, setUpdateIndex] = useState(null);
  const [validation, setValidation] = useState(false);

  const degreelistss = useSelector(
    ({ categary: { degreelist } }) => degreelist,
  );

  const degreeOptions =
    Array.isArray(degreelistss) &&
    degreelistss.map((lang) => ({ value: lang.id, label: lang.title }));
  const dateOptions = generateDateOptions();

  useEffect(() => {
    if (formData.education?.length) {
      setValidation(false);
    }
  }, [formData.education]);

  const openModal = (index) => {
    setUpdateIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setUpdateIndex(null);
  };

  const handleSubmit = (values, { resetForm }) => {
    if (updateIndex !== null) {
      setFormData((prevData) => ({
        ...prevData,
        education: prevData.education.map((edu, index) =>
          index === updateIndex ? values : edu,
        ),
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        education: [...prevData.education, values],
      }));
    }
    closeModal();
    resetForm();
  };

  const deleteEducation = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      education: prevData.education.filter((_, i) => i !== index),
    }));
  };

  const updateEducation = (index) => {
    openModal(index);
  };

  const SubmitandNext = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (formData.education?.length > 0) {
      nextPage();
    } else {
      setValidation(true);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalOpen]);
  return (
    <div>
      {modalOpen && (
        <div
          className="add-education-modal"
          style={{ right: modalOpen ? "0" : "-50%" }}
        >
          <div className="modal-width">
            <div className="modal-head">
              <h3>{updateIndex !== null ? "Edit" : "Add"} Education</h3>
              <button onClick={closeModal} className="btn close-modal-btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
                  alt=""
                />
              </button>
            </div>
            <Formik
              initialValues={
                updateIndex !== null
                  ? formData.education[updateIndex]
                  : {
                      university: "",
                      field: "",
                      degree_id: "",
                      from_year: "",
                      to_year: "",
                    }
              }
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <div className="form-group">
                    <label className="label">School / University <AsteriskLabel /></label>
                    <Field
                      className="form-control"
                      type="text"
                      name="university"
                      placeholder="Enter name"
                    />
                    <ErrorMessage
                      name="university"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="form-group">
                    <label className="label">Degree <AsteriskLabel /></label>
                    <ReactSelect
                      placeholder="Select Degree"
                      options={degreeOptions}
                      value={degreeOptions.find(
                        (option) => option.value === values.degree_id,
                      )}
                      onChange={(option) =>
                        setFieldValue("degree_id", option?.value || "")
                      }
                    />
                    <ErrorMessage
                      name="degree_id"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="form-group">
                    <label className="label">Field of Study <AsteriskLabel /></label>
                    <Field
                      className="form-control"
                      type="text"
                      name="field"
                      placeholder="Type here"
                    />
                    <ErrorMessage
                      name="field"
                      component="div"
                      className="error"
                    />
                  </div>
                  <h4 className="work-title">Dates Attended</h4>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label className="label">From <AsteriskLabel /></label>
                      <ReactSelect
                        placeholder="Select From Year"
                        options={dateOptions}
                        value={dateOptions.find(
                          (option) => option.value === values.from_year,
                        )}
                        onChange={(option) =>
                          setFieldValue("from_year", option?.value || "")
                        }
                      />
                      <ErrorMessage
                        name="from_year"
                        component="div"
                        className="error"
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label">To <AsteriskLabel /></label>
                      <ReactSelect
                        placeholder="Select To Year"
                        options={dateOptions}
                        value={dateOptions.find(
                          (option) => option.value === values.to_year,
                        )}
                        onChange={(option) =>
                          setFieldValue("to_year", option?.value || "")
                        }
                      />
                      <ErrorMessage
                        name="to_year"
                        component="div"
                        className="error"
                      />
                    </div>
                  </div>
                  <div className="add-btn">
                    <button type="submit">
                      {updateIndex !== null ? "Edit" : "Add"} Education
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
      <div className="row about-row">
        <div className="col-md-5 about-left">
          <h6>
            02/9 <span>Qualifications</span>
          </h6>
          <h2>Tell us about your academic qualification</h2>
          <p>Tell us about your experience.</p>
        </div>
        <div className="col-lg-6   about-right">
          <h6>Add Education <AsteriskLabel /></h6>
          {Array.isArray(formData.education) &&
            formData.education.map((item, index) => (
              <div className="add-education-wrapper" key={index}>
                <div className="add-first">
                  <div>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/education.svg`}
                      alt=""
                    />
                  </div>
                  <div>
                    <h2>
                      {
                        degreeOptions.find(
                          (option) => option.value === item.degree_id,
                        )?.label
                      }
                      - {decodeHtml(item.university)}
                    </h2>
                    <h5>{decodeHtml(item.field)}</h5>
                    <OnlyYearRange   fromYear={item.from_year} toYear={item.to_year} />
                  </div>
                </div>
                <div className="add-button-education">
                  <button onClick={() => deleteEducation(index)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                      alt=""
                    />
                  </button>
                  <button onClick={() => updateEducation(index)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            ))}
          {validation && (
            <p style={{ color: "red" }}>At least add one education</p>
          )}
          <button className="add-education-btn" onClick={() => openModal(null)}>
            Add Education
          </button>
        </div>
      </div>
      <div className="button-container">
        <button
          type="button"
          onClick={() => previousPage()}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>
        <button
          type="button"
          onClick={() => SubmitandNext()}
          className="next-button"
        >
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default IAddEduction;
// import React, { useEffect, useState } from "react";
// import ReactSelect from "react-select";
// import CloudStorage from "../../../../../CloudStorage/CloudStorage";
// import { useSelector } from "react-redux";
// import { Formik, Field, Form, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
// import AsteriskLabel from "../../../../Common/AsteriskLabel";
// import YearRange from "../../../../Common/YearRange";

// const options = [
//   { value: "1", label: "BE" },
//   { value: "2", label: "BCA" },
//   { value: "3", label: "MBA" },
//   { value: "4", label: "B.COM" },
// ];

// const validationSchema = Yup.object().shape({
//   university: Yup.string().required("University is required"),
//   field: Yup.string().required("Field of Study is required"),
//   degree_id: Yup.string().required("Degree is required"),
//   from_year: Yup.date()
//     .required("From date is required")
//     .typeError("Please enter a valid date")
//     .max(new Date(), "From date cannot be in the future")
//     .min(new Date(1990, 0, 1), "From date cannot be before 1990"),
//   to_year: Yup.date()
//     .required("To date is required")
//     .typeError("Please enter a valid date")
//     .max(new Date(), "To date cannot be in the future")
//     .min(new Date(1990, 0, 1), "To date cannot be before 1990")
//     .test(
//       "date-comparison",
//       "To date must be after From date",
//       function (value) {
//         const { from_year } = this.parent;
//         if (!value || !from_year) return true;
        
//         const fromDate = new Date(from_year);
//         const toDate = new Date(value);
        
//         // Ensure at least one day difference
//         fromDate.setHours(0, 0, 0, 0);
//         toDate.setHours(0, 0, 0, 0);
        
//         const timeDiff = toDate.getTime() - fromDate.getTime();
//         const dayDiff = timeDiff / (1000 * 3600 * 24);
        
//         return dayDiff >= 1; // At least one day gap
//       }
//     )
//     .test(
//       "year-gap",
//       "Gap between From date and To date must not exceed 10 years",
//       function (value) {
//         const { from_year } = this.parent;
//         if (!from_year || !value) return true;
        
//         const fromDate = new Date(from_year);
//         const toDate = new Date(value);
        
//         // Calculate year gap
//         let yearGap = toDate.getFullYear() - fromDate.getFullYear();
//         const monthDiff = toDate.getMonth() - fromDate.getMonth();
//         const dayDiff = toDate.getDate() - fromDate.getDate();
        
//         // Adjust year gap if the end date hasn't reached the anniversary
//         if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
//           yearGap--;
//         }
        
//         return yearGap <= 10;
//       }
//     ),
// });

// const IAddEduction = ({ formData, setFormData, nextPage, previousPage }) => {
//   const [loading, setLoading] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [updateIndex, setUpdateIndex] = useState(null);
//   const [validation, setValidation] = useState(false);

//   const degreelistss = useSelector(
//     ({ categary: { degreelist } }) => degreelist,
//   );

//   const degreeOptions =
//     Array.isArray(degreelistss) &&
//     degreelistss.map((lang) => ({ value: lang.id, label: lang.title }));

//   useEffect(() => {
//     if (formData.education?.length) {
//       setValidation(false);
//     }
//   }, [formData.education]);

//   const openModal = (index) => {
//     setUpdateIndex(index);
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setUpdateIndex(null);
//   };

//   const handleSubmit = (values, { resetForm }) => {
//     const formattedValues = {
//       ...values,
//       // Ensure we store the date in YYYY-MM-DD format
//       from_year: formatDateForStorage(values.from_year),
//       to_year: formatDateForStorage(values.to_year),
//     };

//     if (updateIndex !== null) {
//       setFormData((prevData) => ({
//         ...prevData,
//         education: prevData.education.map((edu, index) =>
//           index === updateIndex ? formattedValues : edu,
//         ),
//       }));
//     } else {
//       setFormData((prevData) => ({
//         ...prevData,
//         education: [...prevData.education, formattedValues],
//       }));
//     }
//     closeModal();
//     resetForm();
//   };

//   const deleteEducation = (index) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       education: prevData.education.filter((_, i) => i !== index),
//     }));
//   };

//   const updateEducation = (index) => {
//     openModal(index);
//   };

//   const SubmitandNext = async () => {
//     setLoading(true);
//     await new Promise((resolve) => setTimeout(resolve, 1000));
//     if (formData.education?.length > 0) {
//       nextPage();
//     } else {
//       setValidation(true);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     if (modalOpen) {
//       document.body.classList.add('modal-open');
//     } else {
//       document.body.classList.remove('modal-open');
//     }
//     return () => {
//       document.body.classList.remove('modal-open');
//     };
//   }, [modalOpen]);

//   // Helper function to format date for storage
//   const formatDateForStorage = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   // Helper function to get year from date string for display
//   const getYearFromDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.getFullYear().toString();
//   };

//   // Helper function to calculate day difference
//   const calculateDayDifference = (fromDate, toDate) => {
//     if (!fromDate || !toDate) return 0;
    
//     const from = new Date(fromDate);
//     const to = new Date(toDate);
    
//     from.setHours(0, 0, 0, 0);
//     to.setHours(0, 0, 0, 0);
    
//     const timeDiff = to.getTime() - from.getTime();
//     return Math.floor(timeDiff / (1000 * 3600 * 24));
//   };

//   // Helper to format date for input field (YYYY-MM-DD)
//   const formatDateForInput = (dateString) => {
//     if (!dateString) return "";
    
//     // If it's already in YYYY-MM-DD format, return as is
//     if (dateString.includes("-") && dateString.split("-").length === 3) {
//       return dateString;
//     }
    
//     // If it's just a year, add January 1st
//     if (/^\d{4}$/.test(dateString)) {
//       return `${dateString}-01-01`;
//     }
    
//     // Try to parse as date
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";
    
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   return (
//     <div>
//       {modalOpen && (
//         <div
//           className="add-education-modal"
//           style={{ right: modalOpen ? "0" : "-50%" }}
//         >
//           <div className="modal-width">
//             <div className="modal-head">
//               <h3>{updateIndex !== null ? "Edit" : "Add"} Education</h3>
//               <button onClick={closeModal} className="btn close-modal-btn">
//                 <img
//                   src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
//                   alt=""
//                 />
//               </button>
//             </div>
//             <Formik
//               initialValues={
//                 updateIndex !== null
//                   ? {
//                     ...formData.education[updateIndex],
//                     from_year: formatDateForInput(formData.education[updateIndex].from_year),
//                     to_year: formatDateForInput(formData.education[updateIndex].to_year),
//                   }
//                   : {
//                     university: "",
//                     field: "",
//                     degree_id: "",
//                     from_year: "",
//                     to_year: "",
//                   }
//               }
//               validationSchema={validationSchema}
//               onSubmit={handleSubmit}
//               enableReinitialize
//             >
//               {({ setFieldValue, values, errors, touched }) => {
//                 const dayDifference = calculateDayDifference(values.from_year, values.to_year);
                
//                 return (
//                   <Form>
//                     <div className="form-group">
//                       <label className="label">School / University <AsteriskLabel /></label>
//                       <Field
//                         className="form-control"
//                         type="text"
//                         name="university"
//                         placeholder="Enter name"
//                       />
//                       <ErrorMessage
//                         name="university"
//                         component="div"
//                         className="error"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label className="label">Degree <AsteriskLabel /></label>
//                       <ReactSelect
//                         placeholder="Select Degree"
//                         options={degreeOptions}
//                         value={degreeOptions.find(
//                           (option) => option.value === values.degree_id,
//                         )}
//                         onChange={(option) =>
//                           setFieldValue("degree_id", option?.value || "")
//                         }
//                         isClearable
//                       />
//                       <ErrorMessage
//                         name="degree_id"
//                         component="div"
//                         className="error"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label className="label">Field of Study <AsteriskLabel /></label>
//                       <Field
//                         className="form-control"
//                         type="text"
//                         name="field"
//                         placeholder="Type here"
//                       />
//                       <ErrorMessage
//                         name="field"
//                         component="div"
//                         className="error"
//                       />
//                     </div>
                    
//                     <h4 className="work-title">Dates Attended</h4>
//                     <div className="row">
//                       <div className="form-group col-md-6">
//                         <label className="label">From Date <AsteriskLabel /></label>
//                         <input
//                           type="date"
//                           className={`form-control ${touched.from_year && errors.from_year ? 'is-invalid' : ''}`}
//                           value={values.from_year}
//                           onChange={(e) => {
//                             setFieldValue("from_year", e.target.value);
//                           }}
//                           min="1990-01-01"
//                           max={new Date().toISOString().split('T')[0]}
//                         />
//                         <ErrorMessage
//                           name="from_year"
//                           component="div"
//                           className="error"
//                         />
//                         <small className="text-muted">
//                           Selected: {values.from_year ? new Date(values.from_year).toLocaleDateString() : "Not selected"}
//                         </small>
//                       </div>
//                       <div className="form-group col-md-6">
//                         <label className="label">To Date <AsteriskLabel /></label>
//                         <input
//                           type="date"
//                           className={`form-control ${touched.to_year && errors.to_year ? 'is-invalid' : ''}`}
//                           value={values.to_year}
//                           onChange={(e) => {
//                             setFieldValue("to_year", e.target.value);
//                           }}
//                           min={values.from_year ? 
//                             new Date(new Date(values.from_year).getTime() + 86400000).toISOString().split('T')[0] : 
//                             "1990-01-01"
//                           }
//                           max={new Date().toISOString().split('T')[0]}
//                         />
//                         <ErrorMessage
//                           name="to_year"
//                           component="div"
//                           className="error"
//                         />
//                         <small className="text-muted">
//                           Selected: {values.to_year ? new Date(values.to_year).toLocaleDateString() : "Not selected"}
//                           {values.from_year && values.to_year && dayDifference > 0 && (
//                             <span style={{ color: dayDifference < 365 ? 'orange' : 'green', marginLeft: '10px' }}>
//                               ({dayDifference} days / {(dayDifference/365).toFixed(1)} years)
//                             </span>
//                           )}
//                         </small>
//                       </div>
//                     </div>

//                     {/* Date validation summary */}
//                     {values.from_year && values.to_year && dayDifference > 0 && (
//                       <div className="alert alert-info mt-3">
//                         <small>
//                           <strong>Duration:</strong> {dayDifference} days ({getYearFromDate(values.from_year)} to {getYearFromDate(values.to_year)})<br />
//                           <strong>Validation:</strong> {
//                             dayDifference < 1 ? "❌ Must be at least 1 day" :
//                             dayDifference > 3650 ? "❌ Cannot exceed 10 years" :
//                             "✓ Valid duration"
//                           }
//                         </small>
//                       </div>
//                     )}

//                     <div className="add-btn">
//                       <button type="submit" className="btn btn-primary">
//                         {updateIndex !== null ? "Update" : "Add"} Education
//                       </button>
//                     </div>
//                   </Form>
//                 );
//               }}
//             </Formik>
//           </div>
//         </div>
//       )}
      
//       <div className="row about-row">
//         <div className="col-md-5 about-left">
//           <h6>
//             02/9 <span>Qualifications</span>
//           </h6>
//           <h2>Tell us about your academic qualification</h2>
//           <p>Tell us about your experience.</p>
//         </div>
//         <div className="col-lg-6 about-right">
//           <h6>Add Education <AsteriskLabel /></h6>
//           {Array.isArray(formData.education) &&
//             formData.education.map((item, index) => {
//               const fromYear = getYearFromDate(item.from_year);
//               const toYear = getYearFromDate(item.to_year);
//               const dayDiff = calculateDayDifference(item.from_year, item.to_year);
              
//               return (
//                 <div className="add-education-wrapper" key={index}>
//                   <div className="add-first">
//                     <div>
//                       <img
//                         src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/education.svg`}
//                         alt=""
//                       />
//                     </div>
//                     <div>
//                       <h2>
//                         {
//                           degreeOptions.find(
//                             (option) => option.value === item.degree_id,
//                           )?.label
//                         }
//                         - {decodeHtml(item.university)}
//                       </h2>
//                       <h5>{decodeHtml(item.field)}</h5>
//                       <YearRange fromYear={fromYear} toYear={toYear} />
//                       {dayDiff > 0 && (
//                         <small className="text-muted">
//                           ({dayDiff} days / {(dayDiff/365).toFixed(1)} years)
//                         </small>
//                       )}
//                     </div>
//                   </div>
//                   <div className="add-button-education">
//                     <button onClick={() => deleteEducation(index)}>
//                       <img
//                         src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
//                         alt=""
//                       />
//                     </button>
//                     <button onClick={() => updateEducation(index)}>
//                       <img
//                         src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
//                         alt=""
//                       />
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           {validation && (
//             <p style={{ color: "red" }}>At least add one education</p>
//           )}
//           <button className="add-education-btn" onClick={() => openModal(null)}>
//             Add Education
//           </button>
//         </div>
//       </div>
//       <div className="button-container">
//         <button
//           type="button"
//           onClick={() => previousPage()}
//           className="prev-button"
//         >
//           <img
//             src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
//             alt=""
//           />
//           Back
//         </button>
//         <button
//           type="button"
//           onClick={() => SubmitandNext()}
//           className="next-button"
//         >
//           {loading ? (
//             <LoginLoaderButton />
//           ) : (
//             <>
//               Next
//               <img
//                 src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
//                 alt=""
//               />
//             </>
//           )}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default IAddEduction;